import React, { Fragment } from 'react';
import { css } from 'twin.macro';
import EditElement from '../EditElement';
import { AiFillCopy } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import { BootstrapToolTip } from '@/_elements/ToolTip';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

const FormElementControl = React.memo(
    ({ form = {}, onEdit = () => {}, handleCopy = () => {}, handleDelete = () => {} }) => {
        return (
            <div className="form-element-control">
                <Fragment>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <EditElement element={form} onEdit={onEdit} />
                        <Fragment>
                            {form?.specialityKey ? (
                                <BootstrapToolTip text="Speciality Field: Copy/Delete Not Allowed">
                                    <AiOutlineExclamationCircle />
                                </BootstrapToolTip>
                            ) : (
                                <Fragment>
                                    {form.key === 'ServiceRadio' ? null : (
                                        <span
                                            css={css`
                                                cursor: pointer;
                                            `}
                                            onClick={() => handleCopy(form)}
                                        >
                                            <AiFillCopy color="#50aeb0" />
                                        </span>
                                    )}

                                    <span
                                        css={css`
                                            cursor: pointer;
                                            height: 20px;
                                            width: 20px;
                                            margin-bottom: 20px;
                                        `}
                                        onClick={() => handleDelete(form.id)}
                                    >
                                        <MdDelete color="red" />
                                    </span>
                                </Fragment>
                            )}
                        </Fragment>
                    </div>
                </Fragment>
            </div>
        );
    }
);

export default FormElementControl;
